import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgp-nenhum-resultado',
    templateUrl: './nenhum-resultado.component.html'
})
export class NenhumResultadoComponent {}
